import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authService } from '../../Services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search)

  const { from } = location.state || { from: { pathname: "/user/home" } };

  const auth = useSelector((state) => state.auth);
  useEffect(() => {  
    if (auth && auth.token) {
      return navigate(from);
    }
  }, []);
  const [input, setInput] = useState({
    token: params.get("token"),
    password: '',
    confirm_password: '',
  });
  
  const [submitted, setSubmitted] = useState(false);
  const [msg, setMsg] = useState("");
  
  const [validationError, setValidationError] = useState({});
  const ref = useRef([]);

  const submitForm = () => {
    setMsg("");
    if(Object.keys(checkValidation()).length > 0) {
      setSubmitted(false);
      return false;
    }
    
    authService.resetPassword(input).then(auth => {
      setSubmitted(false);
      if(auth.status == 0) {
        setMsg(auth.msg);
        return;
      }
      navigate("/login");
    });
  }

  const handleChange = (e) => {
    setMsg("");
    const { name, value } = e.target;
    setInput(input => ({ ...input, [name]: value }));
  }

  const checkValidation = () => {
    setValidationError({});
    let error = {};
    Object.keys(input).map(item => {
      if(input[item] == "") {
        error[item] = "Required";
      }

      if(input[item]) {
        switch(item) {
          case "confirm_password":
            if(input['password'] != input['confirm_password']) {
              error[item] =  "Password and confirm password are not matching";
            }
            break;
          
          default:
            break;
        }
      }
    });
    if(Object.keys(error).length>0) {
      setValidationError(error);
      const ref_focus_key = Object.keys(error)[0];
      ref.current[ref_focus_key].focus();
    }
    return error;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    submitForm();
  }

  return (
    <>
      {/* <section id="page-banner" className="pt-10 pb-10 bg_cover" data-overlay="8" >
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="page-banner-cont">
                        <h4>Login</h4>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to={"/"}>Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Login</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
      </section> */}

      <section className="pb-50">
        <div className="container">
          <div className="row">
            <div className='col-md-12'>
              <div className="contact-from offset-md-3 col-md-6">
                <fieldset className='border p-4 shadow-lg'>
                  <legend className='w-auto'>
                    Reset Password?
                  </legend>
                  <div className="main-form">
                    <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="singel-form form-group">
                            <input name="password" type="text" placeholder="New Password" value={input.password} ref={r => {ref.current['password'] = r}}  onChange={handleChange} />
                            {validationError.password && <span className='text-danger'>{validationError.password}</span>}
                          </div>
                          <div className="singel-form form-group">
                            <input name="confirm_password" type="text" placeholder="Confirm Password" value={input.confirm_password} ref={r => {ref.current['confirm_password'] = r}}  onChange={handleChange} />
                            {validationError.confirm_password && <span className='text-danger'>{validationError.confirm_password}</span>}
                          </div>
                        </div>
                        <div className="col-md-12">
                          {msg && <p className="msg login text-danger mt-2">{msg}</p>}
                          <div className="singel-form">
                            <button type="submit" className="main-btn disabled">
                              {submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Reset Password</span>}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </fieldset>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResetPassword;